type FilterOptions = {
    category?: string;
    hasStock?: boolean;
};

export function createAlgoliaFiltersString(options: FilterOptions = {}): string {
    const { category, hasStock = true } = options;

    const categoryFilter = category ? `categories:"${category}"` : "";
    const stockFilter = hasStock ? "hasStock:true" : "";

    return [categoryFilter, stockFilter].filter(Boolean).join(" AND ");
}
